/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontWebSongLyricsModel
 */
export interface FrontWebSongLyricsModel {
    /**
     * Text
     * @type {string}
     * @memberof FrontWebSongLyricsModel
     */
    lyrics?: string;
    /**
     * Authors
     * @type {string}
     * @memberof FrontWebSongLyricsModel
     */
    authors?: string;
    /**
     * Album
     * @type {string}
     * @memberof FrontWebSongLyricsModel
     */
    album?: string;
    /**
     * Year
     * @type {string}
     * @memberof FrontWebSongLyricsModel
     */
    year?: string;
    /**
     * 
     * @type {number}
     * @memberof FrontWebSongLyricsModel
     */
    id: number;
    /**
     * Interpret
     * @type {string}
     * @memberof FrontWebSongLyricsModel
     */
    interpret: string;
    /**
     * Název skladby
     * @type {string}
     * @memberof FrontWebSongLyricsModel
     */
    song: string;
    /**
     * Začátek skladby
     * @type {string}
     * @memberof FrontWebSongLyricsModel
     */
    beginAt: string;
    /**
     * Začátek skladby
     * @type {string}
     * @memberof FrontWebSongLyricsModel
     */
    endAt: string;
    /**
     * Obrázek
     * @type {string}
     * @memberof FrontWebSongLyricsModel
     */
    image: string;
    /**
     * Aktivní
     * @type {boolean}
     * @memberof FrontWebSongLyricsModel
     */
    active?: boolean;
    /**
     * Má text (slug radia pro ziskani textu)
     * @type {string}
     * @memberof FrontWebSongLyricsModel
     */
    lyricsRadioSlug: string;
}

/**
 * Check if a given object implements the FrontWebSongLyricsModel interface.
 */
export function instanceOfFrontWebSongLyricsModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "interpret" in value;
    isInstance = isInstance && "song" in value;
    isInstance = isInstance && "beginAt" in value;
    isInstance = isInstance && "endAt" in value;
    isInstance = isInstance && "image" in value;
    isInstance = isInstance && "lyricsRadioSlug" in value;

    return isInstance;
}

export function FrontWebSongLyricsModelFromJSON(json: any): FrontWebSongLyricsModel {
    return FrontWebSongLyricsModelFromJSONTyped(json, false);
}

export function FrontWebSongLyricsModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontWebSongLyricsModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lyrics': !exists(json, 'lyrics') ? undefined : json['lyrics'],
        'authors': !exists(json, 'authors') ? undefined : json['authors'],
        'album': !exists(json, 'album') ? undefined : json['album'],
        'year': !exists(json, 'year') ? undefined : json['year'],
        'id': json['id'],
        'interpret': json['interpret'],
        'song': json['song'],
        'beginAt': json['beginAt'],
        'endAt': json['endAt'],
        'image': json['image'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'lyricsRadioSlug': json['lyricsRadioSlug'],
    };
}

export function FrontWebSongLyricsModelToJSON(value?: FrontWebSongLyricsModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lyrics': value.lyrics,
        'authors': value.authors,
        'album': value.album,
        'year': value.year,
        'id': value.id,
        'interpret': value.interpret,
        'song': value.song,
        'beginAt': value.beginAt,
        'endAt': value.endAt,
        'image': value.image,
        'active': value.active,
        'lyricsRadioSlug': value.lyricsRadioSlug,
    };
}

